export default __webpack_public_path__ + "static/media/si-glyph_money-coin.df750835.svg";